/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { useAppDispatch } from '../../../common/redux/hooks';
import { setTrades } from '../../../common/redux/ducks/contractorRegistrationForm';
import { Checkbox } from '@motili/ui';
import { ReactElement } from 'react';
import { Trade } from '../../../common/types';
import { styled } from 'styled-components';

interface TradeOption {
    trade: string;
    subCategory: string;
}

interface TradeOptionsProps {
    trades: Trade[];
}

const tradeOptions: TradeOption[] = [
    { trade: 'HVAC', subCategory: 'Residential' },
    { trade: 'HVAC', subCategory: 'Commercial' },
    { trade: 'Electrical', subCategory: 'Residential' },
    { trade: 'Electrical', subCategory: 'Commercial' },
    { trade: 'Plumbing', subCategory: 'Residential' },
    { trade: 'Plumbing', subCategory: 'Commercial' },
    { trade: 'Plumbing', subCategory: 'Water Heater' },
];

export default function TradeOptions({
    trades,
}: TradeOptionsProps): ReactElement {
    const dispatch = useAppDispatch();
    const isTradeSelected = (option: TradeOption) =>
        !!trades.some(
            t =>
                t.type === option.trade &&
                t.subCategories.includes(option.subCategory)
        );

    const handleCheckboxChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        { trade, subCategory }: TradeOption
    ) => {
        const existingTrade = trades.find(t => t.type === trade);
        const otherTrades = trades.filter(t => t.type !== trade);
        const current = existingTrade?.subCategories ?? [];

        const subCategories = e.target.checked
            ? [...new Set([...current, subCategory])]
            : current.filter(sc => sc !== subCategory);

        dispatch(
            setTrades(
                subCategories.length
                    ? [...otherTrades, { type: trade, subCategories }]
                    : otherTrades
            )
        );
    };

    const showCheckboxOptions = tradeOptions.map(option => {
        const checked = isTradeSelected(option);
        const id = `${option.trade} - ${option.subCategory}`;
        return (
            <StyledCheckbox
                key={id}
                checked={checked}
                label={id}
                onChange={e => handleCheckboxChange(e, option)}
                name={id}
                value={'false'}
                id={id}
            />
        );
    });

    return <>{showCheckboxOptions}</>;
}

const StyledCheckbox = styled(Checkbox)`
    margin-top: 10px;
`;
